<template>
    <v-snackbar :timeout="3000" bottom right :color="color" v-model="show">
        {{ text }}
        <v-btn v-if="close" dark flat @click.native="show = false" icon>
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</template>
<script>
export default {
    data(){
        return {
            show  : false,
            text  : '',
            color : '',
            close : false
        }
    },
    created() {
        this.$eventHub.$on('SNACK_BAR', this.SetSnackBar);
    },
    beforeDestroy() {
        this.$eventHub.$off('SNACK_BAR');
    },
    methods: {

        SetSnackBar(SnackDetails){
            this.show  = SnackDetails['Show']
            this.text  = SnackDetails['Text']
            this.color = SnackDetails['Color']
            this.close = SnackDetails['Close']            
        }
    }
}
</script>
<style>

</style>